// React Query keys for Evidence Chat. Separate from useChat.ts because
// chatStreamStore.ts writes streamed results into the cache, and importing the
// keys from the hook module would make the two circular.

export const sessionsKey = (projectId: string) => ["chat", "sessions", projectId];
export const messagesKey = (sessionId: string) => ["chat", "messages", sessionId];
